// Single source of truth for the flags this repo checks.
// name    — snake_case, studentportal_-prefixed, matches the gate name in the Statsig console
// default — served when the provider is unreachable/not ready; also what the local provider serves.
//           Release flags default false; only an operational switch that must survive an outage ON
//           may declare default true.
export const FLAGS = {
  STUDENTPORTAL_FLAGS_CANARY: {
    name: "studentportal_flags_canary",
    default: false,
    description:
      "Feature-flag system canary — safe to flip in any tier; proves the local/Statsig wiring end to end",
  },
  STUDENTPORTAL_EDIT_CLASS_REVAMP: {
    name: "studentportal_edit_class_revamp",
    default: false,
    description:
      "Revamped Edit Class page (SPRIN-3248): the EditClass tree on the existing /cancel/reschedule/:studentId route; OFF serves the legacy CancelAndRescheduleV2 screen",
  },
};

const byName = Object.values(FLAGS).reduce(
  (acc, flag) => ({ ...acc, [flag.name]: flag }),
  {},
);

export const defaultFor = (flagName) => byName[flagName]?.default ?? false;
